import React, { useState } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { BookOpenIcon, ClockIcon, CalendarIcon, MapPinIcon, AwardIcon, UsersIcon, UserIcon, DownloadIcon, CheckIcon, ShieldIcon, StarIcon, BadgeCheckIcon, ArrowRightIcon, FileTextIcon, MessageCircleIcon, BookIcon, ChevronRightIcon, PlayCircleIcon, AlertCircleIcon, PlusIcon, MinusIcon, ThermometerIcon, UtensilsIcon, WashingMachineIcon, BuildingIcon, BarChartIcon, ClipboardCheckIcon, DatabaseIcon, ShieldCheckIcon } from 'lucide-react';
export const MinimalCoursePage = () => {
  const [activeTab, setActiveTab] = useState('overview');
  return <div className="min-h-screen bg-white w-full" data-id="element-3377">
      <Header data-id="element-3378" />
      <main data-id="element-3379">
        <HeroSection data-id="element-3380" />
        <CourseHeader data-id="element-3381" />
        {/* Course Navigation Tabs */}
        <div className="border-b border-gray-200 sticky top-20 bg-white z-30" data-id="element-3382">
          <div className="container mx-auto px-4 flex overflow-x-auto" data-id="element-3383">
            <button onClick={() => setActiveTab('overview')} className={`px-5 py-4 font-medium text-sm whitespace-nowrap border-b-2 transition-colors ${activeTab === 'overview' ? 'border-teal text-teal' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-3384">
              Overview
            </button>
            <button onClick={() => setActiveTab('curriculum')} className={`px-5 py-4 font-medium text-sm whitespace-nowrap border-b-2 transition-colors ${activeTab === 'curriculum' ? 'border-teal text-teal' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-3385">
              Curriculum
            </button>
            <button onClick={() => setActiveTab('instructor')} className={`px-5 py-4 font-medium text-sm whitespace-nowrap border-b-2 transition-colors ${activeTab === 'instructor' ? 'border-teal text-teal' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-3386">
              Instructor
            </button>
            <button onClick={() => setActiveTab('certificate')} className={`px-5 py-4 font-medium text-sm whitespace-nowrap border-b-2 transition-colors ${activeTab === 'certificate' ? 'border-teal text-teal' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-3387">
              Certificate
            </button>
            <button onClick={() => setActiveTab('accessibility')} className={`px-5 py-4 font-medium text-sm whitespace-nowrap border-b-2 transition-colors ${activeTab === 'accessibility' ? 'border-teal text-teal' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-3388">
              Accessibility
            </button>
            <button onClick={() => setActiveTab('reviews')} className={`px-5 py-4 font-medium text-sm whitespace-nowrap border-b-2 transition-colors ${activeTab === 'reviews' ? 'border-teal text-teal' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-3389">
              Reviews
            </button>
            <button onClick={() => setActiveTab('faq')} className={`px-5 py-4 font-medium text-sm whitespace-nowrap border-b-2 transition-colors ${activeTab === 'faq' ? 'border-teal text-teal' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-3390">
              FAQ
            </button>
          </div>
        </div>
        {/* Tab Content */}
        <div className="py-12" data-id="element-3391">
          {activeTab === 'overview' && <OverviewContent data-id="element-3392" />}
          {activeTab === 'curriculum' && <CurriculumContent data-id="element-3393" />}
          {activeTab === 'instructor' && <InstructorContent data-id="element-3394" />}
          {activeTab === 'certificate' && <CertificateContent data-id="element-3395" />}
          {activeTab === 'accessibility' && <AccessibilityContent data-id="element-3396" />}
          {activeTab === 'reviews' && <ReviewsContent data-id="element-3397" />}
          {activeTab === 'faq' && <FaqContent data-id="element-3398" />}
        </div>
        <CoursePricing data-id="element-3399" />
      </main>
      <Footer data-id="element-3400" />
    </div>;
};
const HeroSection = () => {
  return <section className="relative pt-24 pb-16 overflow-hidden" data-id="element-3401">
      {/* Background with enhanced overlay */}
      <div className="absolute inset-0 z-0" data-id="element-3402">
        <img src="https://images.unsplash.com/photo-1556911220-e15b29be8c8f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Professional Kitchen Environment in Ireland" className="w-full h-full object-cover" data-id="element-3403" />
        <div className="absolute inset-0 bg-gradient-to-r from-charcoal/95 via-charcoal/85 to-charcoal/75" data-id="element-3404"></div>
      </div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-3405">
        <div className="max-w-4xl" data-id="element-3406">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-teal/20 backdrop-blur-sm border border-teal/30 mb-6" data-id="element-3407">
            <BadgeCheckIcon className="h-4 w-4 text-aqua mr-2" data-id="element-3408" />
            <span className="text-white/90 text-sm font-medium" data-id="element-3409">
              FSAI Compliant Training
            </span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-white leading-tight" data-id="element-3410">
            Level 1 Food Safety Training
            <span className="block text-gradient bg-gradient-to-r from-teal to-aqua bg-clip-text text-transparent" data-id="element-3411">
              For Ireland
            </span>
          </h1>
          <p className="text-xl text-white/90 mb-8 leading-relaxed max-w-3xl" data-id="element-3412">
            Essential training for all food handlers in Ireland. Get certified
            today with our FSAI-compliant course and meet your legal
            obligations.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-3413">
            <div className="flex items-center bg-white/10 backdrop-blur-sm px-4 py-3 rounded-lg" data-id="element-3414">
              <ClockIcon className="h-5 w-5 text-aqua mr-3 flex-shrink-0" data-id="element-3415" />
              <span className="text-white" data-id="element-3416">Complete in 2 Hours</span>
            </div>
            <div className="flex items-center bg-white/10 backdrop-blur-sm px-4 py-3 rounded-lg" data-id="element-3417">
              <ShieldIcon className="h-5 w-5 text-aqua mr-3 flex-shrink-0" data-id="element-3418" />
              <span className="text-white" data-id="element-3419">FSAI Compliant</span>
            </div>
            <div className="flex items-center bg-white/10 backdrop-blur-sm px-4 py-3 rounded-lg" data-id="element-3420">
              <AwardIcon className="h-5 w-5 text-aqua mr-3 flex-shrink-0" data-id="element-3421" />
              <span className="text-white" data-id="element-3422">Instant Certificate</span>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-3423">
            <a href="#enrollment" className="px-6 py-3.5 bg-teal text-white font-medium rounded-lg hover:bg-gradient-to-r hover:from-teal hover:to-aqua transition-all duration-300 text-center shadow-lg flex items-center justify-center" data-id="element-3424">
              Enroll Now - Just €19
              <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-3425" />
            </a>
            <a href="#group-enrollment" className="px-6 py-3.5 bg-transparent text-white font-medium rounded-lg border-2 border-white hover:bg-white/10 transition-all duration-300 text-center flex items-center justify-center" data-id="element-3426">
              <UsersIcon className="mr-2 h-5 w-5" data-id="element-3427" />
              Team Booking
            </a>
          </div>
        </div>
      </div>
    </section>;
};
const CourseHeader = () => {
  return <header className="bg-white border-b border-gray-200 sticky top-0 z-20" data-id="element-3428">
      <div className="container mx-auto px-4 py-4" data-id="element-3429">
        <div className="flex items-center justify-between" data-id="element-3430">
          <div className="flex items-center" data-id="element-3431">
            <div className="w-10 h-10 rounded-full bg-teal/20 flex items-center justify-center mr-3" data-id="element-3432">
              <BookIcon className="h-6 w-6 text-teal" data-id="element-3433" />
            </div>
            <h1 className="text-2xl font-bold text-charcoal" data-id="element-3434">
              Food Safety Training
            </h1>
          </div>
          <div className="flex items-center space-x-4" data-id="element-3435">
            <a href="#enrollment" className="px-4 py-2 bg-teal text-white font-medium rounded-lg hover:bg-teal/90 transition-all duration-300" data-id="element-3436">
              Enroll Now
            </a>
            <a href="#group-enrollment" className="px-4 py-2 bg-transparent text-teal font-medium rounded-lg border border-teal hover:bg-teal/10 transition-all duration-300" data-id="element-3437">
              Team Booking
            </a>
          </div>
        </div>
      </div>
    </header>;
};
const CoursePricing = () => {
  return <div className="bg-white border-t border-gray-200 py-12" data-id="element-3438">
      <div className="container mx-auto px-4" data-id="element-3439">
        <h2 className="text-3xl font-bold mb-8 text-charcoal" data-id="element-3440">
          Pricing Options
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-3441">
          <div className="bg-teal/5 rounded-xl p-8 border border-teal/10" data-id="element-3442">
            <div className="flex items-center mb-6" data-id="element-3443">
              <div className="w-12 h-12 rounded-full bg-teal/20 flex items-center justify-center mr-4" data-id="element-3444">
                <UserIcon className="h-6 w-6 text-teal" data-id="element-3445" />
              </div>
              <div data-id="element-3446">
                <h3 className="text-xl font-bold text-charcoal" data-id="element-3447">Individual</h3>
                <p className="text-charcoal/70" data-id="element-3448">
                  For personal use or small teams
                </p>
              </div>
            </div>
            <div className="space-y-4 mb-6" data-id="element-3449">
              <div className="flex items-center" data-id="element-3450">
                <div className="w-8 h-8 rounded-full bg-teal/10 flex items-center justify-center mr-3" data-id="element-3451">
                  <CheckIcon className="h-4 w-4 text-teal" data-id="element-3452" />
                </div>
                <span className="text-charcoal/80" data-id="element-3453">€19 per person</span>
              </div>
              <div className="flex items-center" data-id="element-3454">
                <div className="w-8 h-8 rounded-full bg-teal/10 flex items-center justify-center mr-3" data-id="element-3455">
                  <CheckIcon className="h-4 w-4 text-teal" data-id="element-3456" />
                </div>
                <span className="text-charcoal/80" data-id="element-3457">Instant certificate</span>
              </div>
              <div className="flex items-center" data-id="element-3458">
                <div className="w-8 h-8 rounded-full bg-teal/10 flex items-center justify-center mr-3" data-id="element-3459">
                  <CheckIcon className="h-4 w-4 text-teal" data-id="element-3460" />
                </div>
                <span className="text-charcoal/80" data-id="element-3461">24/7 support</span>
              </div>
            </div>
            <a href="#enrollment" className="block w-full py-3 bg-teal text-white font-medium rounded-lg hover:bg-teal/90 transition-all duration-300 text-center" data-id="element-3462">
              Enroll Now
            </a>
          </div>
          <div className="bg-teal/5 rounded-xl p-8 border border-teal/10" data-id="element-3463">
            <div className="flex items-center mb-6" data-id="element-3464">
              <div className="w-12 h-12 rounded-full bg-teal/20 flex items-center justify-center mr-4" data-id="element-3465">
                <UsersIcon className="h-6 w-6 text-teal" data-id="element-3466" />
              </div>
              <div data-id="element-3467">
                <h3 className="text-xl font-bold text-charcoal" data-id="element-3468">Team</h3>
                <p className="text-charcoal/70" data-id="element-3469">
                  For businesses and organizations
                </p>
              </div>
            </div>
            <div className="space-y-4 mb-6" data-id="element-3470">
              <div className="flex items-center" data-id="element-3471">
                <div className="w-8 h-8 rounded-full bg-teal/10 flex items-center justify-center mr-3" data-id="element-3472">
                  <CheckIcon className="h-4 w-4 text-teal" data-id="element-3473" />
                </div>
                <span className="text-charcoal/80" data-id="element-3474">€15 per person</span>
              </div>
              <div className="flex items-center" data-id="element-3475">
                <div className="w-8 h-8 rounded-full bg-teal/10 flex items-center justify-center mr-3" data-id="element-3476">
                  <CheckIcon className="h-4 w-4 text-teal" data-id="element-3477" />
                </div>
                <span className="text-charcoal/80" data-id="element-3478">Team dashboard</span>
              </div>
              <div className="flex items-center" data-id="element-3479">
                <div className="w-8 h-8 rounded-full bg-teal/10 flex items-center justify-center mr-3" data-id="element-3480">
                  <CheckIcon className="h-4 w-4 text-teal" data-id="element-3481" />
                </div>
                <span className="text-charcoal/80" data-id="element-3482">Compliance reports</span>
              </div>
            </div>
            <a href="#group-enrollment" className="block w-full py-3 bg-teal text-white font-medium rounded-lg hover:bg-teal/90 transition-all duration-300 text-center" data-id="element-3483">
              Book for Team
            </a>
          </div>
          <div className="bg-white rounded-xl p-8 border border-gray-200" data-id="element-3484">
            <div className="flex items-center mb-6" data-id="element-3485">
              <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mr-4" data-id="element-3486">
                <ShieldIcon className="h-6 w-6 text-gray-600" data-id="element-3487" />
              </div>
              <div data-id="element-3488">
                <h3 className="text-xl font-bold text-charcoal" data-id="element-3489">Enterprise</h3>
                <p className="text-charcoal/70" data-id="element-3490">For large organizations</p>
              </div>
            </div>
            <div className="space-y-4 mb-6" data-id="element-3491">
              <div className="flex items-center" data-id="element-3492">
                <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center mr-3" data-id="element-3493">
                  <CheckIcon className="h-4 w-4 text-gray-600" data-id="element-3494" />
                </div>
                <span className="text-charcoal/80" data-id="element-3495">Custom pricing</span>
              </div>
              <div className="flex items-center" data-id="element-3496">
                <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center mr-3" data-id="element-3497">
                  <CheckIcon className="h-4 w-4 text-gray-600" data-id="element-3498" />
                </div>
                <span className="text-charcoal/80" data-id="element-3499">Dedicated support</span>
              </div>
              <div className="flex items-center" data-id="element-3500">
                <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center mr-3" data-id="element-3501">
                  <CheckIcon className="h-4 w-4 text-gray-600" data-id="element-3502" />
                </div>
                <span className="text-charcoal/80" data-id="element-3503">White-label options</span>
              </div>
            </div>
            <a href="/contact-sales" className="block w-full py-3 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-all duration-300 text-center" data-id="element-3504">
              Contact Sales
            </a>
          </div>
        </div>
        <div className="mt-12 p-6 bg-teal/5 rounded-xl border border-teal/10" data-id="element-3505">
          <div className="flex items-start" data-id="element-3506">
            <div className="w-10 h-10 rounded-full bg-teal/20 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-3507">
              <CheckIcon className="h-5 w-5 text-teal" data-id="element-3508" />
            </div>
            <div data-id="element-3509">
              <h3 className="font-bold text-charcoal mb-2" data-id="element-3510">
                All Team Licenses Include:
              </h3>
              <ul className="text-charcoal/80 space-y-1" data-id="element-3511">
                <li className="flex items-center" data-id="element-3512">
                  <CheckIcon className="h-4 w-4 text-teal mr-2" data-id="element-3513" />
                  <span data-id="element-3514">Free access to management dashboard</span>
                </li>
                <li className="flex items-center" data-id="element-3515">
                  <CheckIcon className="h-4 w-4 text-teal mr-2" data-id="element-3516" />
                  <span data-id="element-3517">Automated compliance tracking</span>
                </li>
                <li className="flex items-center" data-id="element-3518">
                  <CheckIcon className="h-4 w-4 text-teal mr-2" data-id="element-3519" />
                  <span data-id="element-3520">Compliance reporting tools</span>
                </li>
                <li className="flex items-center" data-id="element-3521">
                  <CheckIcon className="h-4 w-4 text-teal mr-2" data-id="element-3522" />
                  <span data-id="element-3523">Secure cloud storage</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
const TabButton = ({
  active,
  label,
  onClick
}) => {
  return <button onClick={onClick} className={`pb-4 px-1 font-medium text-base whitespace-nowrap transition-colors ${active ? 'text-teal border-b-2 border-teal' : 'text-charcoal/60 hover:text-charcoal'}`} data-id="element-3524">
      {label}
    </button>;
};
const OverviewContent = () => {
  return <div className="max-w-6xl mx-auto" data-id="element-3525">
      <h2 className="text-3xl font-bold mb-8 text-charcoal" data-id="element-3526">Course Overview</h2>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-3527">
        <div className="lg:col-span-2" data-id="element-3528">
          <p className="text-lg text-charcoal/80 mb-6" data-id="element-3529">
            Our Level 1 Food Safety course provides essential knowledge for
            anyone who works with or around food in Ireland
          </p>
          <p className="text-charcoal/80 mb-6" data-id="element-3530">
            The Level 1 Food Safety Training Course is the essential induction
            programme for all food handlers in Ireland. This comprehensive
            course covers the fundamental principles of food safety, providing
            you with the essential knowledge to prevent contamination, protect
            consumers, and meet your legal obligations under Irish food law.
          </p>
          <p className="text-charcoal/80 mb-6" data-id="element-3531">
            Whether you're just starting your career in the food industry or
            need to fulfill compliance requirements, this course delivers the
            critical information you need in a clear, engaging format that's
            easy to understand and apply in your workplace.
          </p>
          <p className="text-charcoal/80 mb-8" data-id="element-3532">
            Fully compliant with Food Safety Authority of Ireland (FSAI) Level 1
            training requirements, this certification is recognized by employers
            and Environmental Health Officers throughout Ireland, making it the
            perfect foundation for your food safety training.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10" data-id="element-3533">
            <div className="flex items-center" data-id="element-3534">
              <div className="w-6 h-6 rounded-full bg-teal/10 flex items-center justify-center mr-3" data-id="element-3535">
                <CheckIcon className="h-4 w-4 text-teal" data-id="element-3536" />
              </div>
              <span className="text-charcoal/80" data-id="element-3537">FSAI compliant</span>
            </div>
            <div className="flex items-center" data-id="element-3538">
              <div className="w-6 h-6 rounded-full bg-teal/10 flex items-center justify-center mr-3" data-id="element-3539">
                <CheckIcon className="h-4 w-4 text-teal" data-id="element-3540" />
              </div>
              <span className="text-charcoal/80" data-id="element-3541">Nationally recognized</span>
            </div>
            <div className="flex items-center" data-id="element-3542">
              <div className="w-6 h-6 rounded-full bg-teal/10 flex items-center justify-center mr-3" data-id="element-3543">
                <CheckIcon className="h-4 w-4 text-teal" data-id="element-3544" />
              </div>
              <span className="text-charcoal/80" data-id="element-3545">Valid for 2-3 years</span>
            </div>
            <div className="flex items-center" data-id="element-3546">
              <div className="w-6 h-6 rounded-full bg-teal/10 flex items-center justify-center mr-3" data-id="element-3547">
                <CheckIcon className="h-4 w-4 text-teal" data-id="element-3548" />
              </div>
              <span className="text-charcoal/80" data-id="element-3549">Meets legal requirements</span>
            </div>
          </div>
        </div>
        <div className="lg:col-span-1" data-id="element-3550">
          <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-3551">
            <h3 className="text-xl font-bold mb-6 text-charcoal" data-id="element-3552">
              Course Details
            </h3>
            <div className="space-y-6" data-id="element-3553">
              <div className="flex items-start" data-id="element-3554">
                <ClockIcon className="h-5 w-5 text-charcoal/70 mt-0.5 mr-3 flex-shrink-0" data-id="element-3555" />
                <div data-id="element-3556">
                  <h4 className="font-bold text-charcoal mb-1" data-id="element-3557">Duration</h4>
                  <p className="text-charcoal/70" data-id="element-3558">
                    Approximately 2 hours to complete
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-3559">
                <BookOpenIcon className="h-5 w-5 text-charcoal/70 mt-0.5 mr-3 flex-shrink-0" data-id="element-3560" />
                <div data-id="element-3561">
                  <h4 className="font-bold text-charcoal mb-1" data-id="element-3562">
                    Course Format
                  </h4>
                  <p className="text-charcoal/70" data-id="element-3563">
                    Interactive video lessons with quizzes
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-3564">
                <AwardIcon className="h-5 w-5 text-charcoal/70 mt-0.5 mr-3 flex-shrink-0" data-id="element-3565" />
                <div data-id="element-3566">
                  <h4 className="font-bold text-charcoal mb-1" data-id="element-3567">
                    Certification
                  </h4>
                  <p className="text-charcoal/70" data-id="element-3568">
                    Instant downloadable certificate
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-3569">
                <ShieldIcon className="h-5 w-5 text-charcoal/70 mt-0.5 mr-3 flex-shrink-0" data-id="element-3570" />
                <div data-id="element-3571">
                  <h4 className="font-bold text-charcoal mb-1" data-id="element-3572">Compliance</h4>
                  <p className="text-charcoal/70" data-id="element-3573">
                    Meets FSAI Level 1 requirements
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-8 pt-6 border-t border-gray-200" data-id="element-3574">
              <div className="flex justify-between items-center mb-2" data-id="element-3575">
                <span className="font-medium text-charcoal" data-id="element-3576">For Me:</span>
                <span className="text-xl font-bold text-charcoal" data-id="element-3577">€19</span>
              </div>
              <div className="flex justify-between items-center mb-6" data-id="element-3578">
                <span className="font-medium text-charcoal" data-id="element-3579">For Teams:</span>
                <span className="text-xl font-bold text-charcoal" data-id="element-3580">
                  Starting at €15
                </span>
              </div>
              <p className="text-sm text-charcoal/60 mb-6" data-id="element-3581">
                Team pricing varies based on group size. Volume discounts
                available for 10+ participants.
              </p>
              <div className="space-y-3" data-id="element-3582">
                <a href="#enrollment" className="flex justify-center items-center w-full py-3 bg-teal text-white font-medium rounded-lg hover:bg-teal/90 transition-all duration-300" data-id="element-3583">
                  <UserIcon className="h-4 w-4 mr-2" data-id="element-3584" />
                  Book for Me - €19
                </a>
                <a href="#group-enrollment" className="flex justify-center items-center w-full py-3 border border-teal text-teal bg-white font-medium rounded-lg hover:bg-teal/5 transition-all duration-300" data-id="element-3585">
                  <UsersIcon className="h-4 w-4 mr-2" data-id="element-3586" />
                  Book for Teams - From €15
                </a>
                <a href="/brochure" className="flex justify-center items-center w-full py-3 text-charcoal/70 hover:text-charcoal transition-all duration-300" data-id="element-3587">
                  <DownloadIcon className="h-4 w-4 mr-2" data-id="element-3588" />
                  Download Course Brochure
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
const CurriculumContent = () => {
  const [openModule, setOpenModule] = useState(1);
  const toggleModule = moduleId => {
    setOpenModule(openModule === moduleId ? null : moduleId);
  };
  const modules = [{
    id: 1,
    title: 'Introduction to Food Safety in Ireland',
    lessons: ['Irish Food Safety Regulatory Framework', 'Role of the Food Safety Authority of Ireland (FSAI)', 'Legal Responsibilities of Food Handlers'],
    duration: '15 minutes'
  }, {
    id: 2,
    title: 'Food Safety Hazards and Contamination',
    lessons: ['Biological, Chemical, and Physical Hazards', 'Cross-Contamination Prevention', 'High-Risk Foods in the Irish Context'],
    duration: '25 minutes'
  }, {
    id: 3,
    title: 'Personal Hygiene for Food Handlers',
    lessons: ['Handwashing Techniques and Frequency', 'Appropriate Workwear and PPE', 'Reporting Illness and Exclusion Periods'],
    duration: '20 minutes'
  }, {
    id: 4,
    title: 'Safe Food Handling Practices',
    lessons: ['Safe Storage and Stock Rotation', 'Temperature Control and Monitoring', 'Food Preparation Guidelines'],
    duration: '25 minutes'
  }, {
    id: 5,
    title: 'Cleaning and Sanitising',
    lessons: ['Cleaning vs. Sanitising Procedures', 'Chemical Safety and Storage', 'Cleaning Schedules and Documentation'],
    duration: '15 minutes'
  }, {
    id: 6,
    title: 'Introduction to HACCP and Allergens',
    lessons: ['Basic HACCP Principles', 'Critical Control Points', 'Allergen Management in Irish Food Businesses'],
    duration: '20 minutes'
  }];
  return <div className="max-w-6xl mx-auto" data-id="element-3589">
      <h2 className="text-3xl font-bold mb-8 text-charcoal" data-id="element-3590">
        Course Curriculum
      </h2>
      <p className="text-lg text-charcoal/70 mb-8" data-id="element-3591">
        Our comprehensive curriculum covers all essential aspects of Level 1
        Food Safety for Ireland
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10" data-id="element-3592">
        <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-3593">
          <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-3594">
            <BookOpenIcon className="h-6 w-6 text-teal" data-id="element-3595" />
          </div>
          <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-3596">
            Food Safety Fundamentals
          </h3>
          <p className="text-charcoal/70 mb-4" data-id="element-3597">
            Explain the difference between food safety and food hygiene, and
            understand food contamination and cross-contamination principles.
          </p>
        </div>
        <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-3598">
          <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-3599">
            <WashingMachineIcon className="h-6 w-6 text-teal" data-id="element-3600" />
          </div>
          <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-3601">
            Personal Hygiene
          </h3>
          <p className="text-charcoal/70 mb-4" data-id="element-3602">
            Learn proper handwashing techniques, maintain personal hygiene, and
            understand proper uniform practices for food safety.
          </p>
        </div>
        <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-3603">
          <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-3604">
            <ThermometerIcon className="h-6 w-6 text-teal" data-id="element-3605" />
          </div>
          <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-3606">
            Temperature Control
          </h3>
          <p className="text-charcoal/70 mb-4" data-id="element-3607">
            Understand the critical temperature zones and how to monitor food
            temperatures to prevent bacterial growth.
          </p>
        </div>
      </div>
      {modules.map(module => <div key={module.id} className="mb-4 border border-gray-200 rounded-xl overflow-hidden" data-id="element-3608">
          <button onClick={() => toggleModule(module.id)} className="flex items-center justify-between w-full p-5 bg-white hover:bg-gray-50 transition-colors text-left" data-id="element-3609">
            <div className="flex items-center" data-id="element-3610">
              <div className="w-10 h-10 rounded-full bg-teal/10 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-3611">
                <span className="font-bold text-teal" data-id="element-3612">{module.id}</span>
              </div>
              <div data-id="element-3613">
                <h3 className="text-lg font-bold text-charcoal" data-id="element-3614">
                  {module.title}
                </h3>
                <p className="text-charcoal/60 text-sm" data-id="element-3615">{module.duration}</p>
              </div>
            </div>
            {openModule === module.id ? <MinusIcon className="h-5 w-5 text-teal" data-id="element-3616" /> : <PlusIcon className="h-5 w-5 text-teal" data-id="element-3617" />}
          </button>
          {openModule === module.id && <div className="p-5 bg-gray-50 border-t border-gray-200" data-id="element-3618">
              <ul className="space-y-3" data-id="element-3619">
                {module.lessons.map((lesson, index) => <li key={index} className="flex items-start" data-id="element-3620">
                    <CheckIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-3621" />
                    <span className="text-charcoal/80" data-id="element-3622">{lesson}</span>
                  </li>)}
              </ul>
            </div>}
        </div>)}
      <div className="mt-10 p-6 bg-teal/10 rounded-xl" data-id="element-3623">
        <div className="flex items-start" data-id="element-3624">
          <AwardIcon className="h-6 w-6 text-teal mr-4 flex-shrink-0 mt-1" data-id="element-3625" />
          <div data-id="element-3626">
            <h3 className="text-lg font-bold text-charcoal mb-2" data-id="element-3627">
              Final Assessment
            </h3>
            <p className="text-charcoal/70 mb-2" data-id="element-3628">
              Complete a comprehensive assessment to test your knowledge and
              earn your certification.
            </p>
            <p className="text-charcoal/70" data-id="element-3629">
              <strong data-id="element-3630">Pass Mark:</strong> 70% | <strong data-id="element-3631">Time Limit:</strong> 30
              minutes | <strong data-id="element-3632">Attempts:</strong> Unlimited
            </p>
          </div>
        </div>
      </div>
    </div>;
};
const InstructorContent = () => {
  return <div className="max-w-6xl mx-auto" data-id="element-3633">
      <h2 className="text-3xl font-bold mb-8 text-charcoal" data-id="element-3634">
        Instructor Information
      </h2>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-3635">
        <div data-id="element-3636">
          <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-200" data-id="element-3637">
            <div className="flex items-center mb-6" data-id="element-3638">
              <div className="w-16 h-16 rounded-full bg-teal/20 flex items-center justify-center mr-6" data-id="element-3639">
                <UserIcon className="h-10 w-10 text-teal" data-id="element-3640" />
              </div>
              <div data-id="element-3641">
                <h3 className="text-2xl font-bold text-charcoal" data-id="element-3642">
                  Dr. Aisling O'Connor
                </h3>
                <p className="text-charcoal/70" data-id="element-3643">Lead Food Safety Instructor</p>
              </div>
            </div>
            <p className="text-charcoal/80 mb-6" data-id="element-3644">
              Dr. Aisling O'Connor is a qualified food safety professional with
              over 15 years of experience in food service management and food
              safety training. She holds a PhD in Food Science and has worked
              with food businesses across Ireland, developing practical training
              programs that meet both regulatory requirements and real-world
              challenges.
            </p>
            <div className="space-y-4" data-id="element-3645">
              <div className="flex items-start" data-id="element-3646">
                <div className="w-8 h-8 rounded-full bg-teal/10 flex items-center justify-center mr-3 flex-shrink-0" data-id="element-3647">
                  <CheckIcon className="h-4 w-4 text-teal" data-id="element-3648" />
                </div>
                <div data-id="element-3649">
                  <h4 className="font-bold text-charcoal" data-id="element-3650">FSAI Certified</h4>
                  <p className="text-charcoal/70" data-id="element-3651">
                    Food Safety Authority of Ireland Level 1 & 2
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-3652">
                <div className="w-8 h-8 rounded-full bg-teal/10 flex items-center justify-center mr-3 flex-shrink-0" data-id="element-3653">
                  <CheckIcon className="h-4 w-4 text-teal" data-id="element-3654" />
                </div>
                <div data-id="element-3655">
                  <h4 className="font-bold text-charcoal" data-id="element-3656">
                    Industry Experience
                  </h4>
                  <p className="text-charcoal/70" data-id="element-3657">
                    15+ years in food service management
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-3658">
                <div className="w-8 h-8 rounded-full bg-teal/10 flex items-center justify-center mr-3 flex-shrink-0" data-id="element-3659">
                  <CheckIcon className="h-4 w-4 text-teal" data-id="element-3660" />
                </div>
                <div data-id="element-3661">
                  <h4 className="font-bold text-charcoal" data-id="element-3662">
                    Training Development
                  </h4>
                  <p className="text-charcoal/70" data-id="element-3663">
                    Created 20+ food safety training programs
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div data-id="element-3664">
          <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-200" data-id="element-3665">
            <h3 className="text-xl font-bold mb-6 text-charcoal" data-id="element-3666">
              Instructor Philosophy
            </h3>
            <p className="text-charcoal/80 mb-6" data-id="element-3667">
              "My approach to food safety training is to make it practical,
              relevant, and accessible. I believe that food safety should be
              taught not as a set of abstract rules, but as a set of practical
              skills that every food handler can apply in their daily work. The
              goal is to create confident, competent food handlers who
              understand the importance of food safety and can make informed
              decisions that protect both their customers and their businesses."
            </p>
            <h3 className="text-xl font-bold mb-6 text-charcoal" data-id="element-3668">
              Training Methodology
            </h3>
            <div className="space-y-4" data-id="element-3669">
              <div className="flex items-start" data-id="element-3670">
                <div className="w-8 h-8 rounded-full bg-teal/10 flex items-center justify-center mr-3 flex-shrink-0" data-id="element-3671">
                  <CheckIcon className="h-4 w-4 text-teal" data-id="element-3672" />
                </div>
                <div data-id="element-3673">
                  <h4 className="font-bold text-charcoal" data-id="element-3674">
                    Interactive Learning
                  </h4>
                  <p className="text-charcoal/70" data-id="element-3675">
                    Real-world scenarios and hands-on activities
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-3676">
                <div className="w-8 h-8 rounded-full bg-teal/10 flex items-center justify-center mr-3 flex-shrink-0" data-id="element-3677">
                  <CheckIcon className="h-4 w-4 text-teal" data-id="element-3678" />
                </div>
                <div data-id="element-3679">
                  <h4 className="font-bold text-charcoal" data-id="element-3680">
                    Practical Application
                  </h4>
                  <p className="text-charcoal/70" data-id="element-3681">
                    Focus on skills that can be immediately applied
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-3682">
                <div className="w-8 h-8 rounded-full bg-teal/10 flex items-center justify-center mr-3 flex-shrink-0" data-id="element-3683">
                  <CheckIcon className="h-4 w-4 text-teal" data-id="element-3684" />
                </div>
                <div data-id="element-3685">
                  <h4 className="font-bold text-charcoal" data-id="element-3686">Compliance Focus</h4>
                  <p className="text-charcoal/70" data-id="element-3687">
                    Training that meets all FSAI requirements
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
const CertificateContent = () => {
  return <div className="max-w-6xl mx-auto" data-id="element-3688">
      <h2 className="text-3xl font-bold mb-8 text-charcoal" data-id="element-3689">
        Accredited Food Safety Certificate
      </h2>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-3690">
        <div data-id="element-3691">
          <p className="text-lg text-charcoal/80 mb-6" data-id="element-3692">
            On successful completion of this course, you will receive a Level 1
            Food Safety Certificate that is fully recognized throughout Ireland
            and compliant with all FSAI requirements.
          </p>
          <div className="space-y-6 mb-8" data-id="element-3693">
            <div className="flex items-start" data-id="element-3694">
              <BadgeCheckIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-3695" />
              <div data-id="element-3696">
                <p className="font-medium text-charcoal" data-id="element-3697">FSAI Aligned</p>
                <p className="text-charcoal/70" data-id="element-3698">
                  Fully compliant with Food Safety Authority of Ireland Level 1
                  requirements
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-3699">
              <BadgeCheckIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-3700" />
              <div data-id="element-3701">
                <p className="font-medium text-charcoal" data-id="element-3702">
                  Nationally Recognized
                </p>
                <p className="text-charcoal/70" data-id="element-3703">
                  Accepted by Irish employers, Environmental Health Officers
                  (EHOs), and food safety inspectors
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-3704">
              <BadgeCheckIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-3705" />
              <div data-id="element-3706">
                <p className="font-medium text-charcoal" data-id="element-3707">Instant Download</p>
                <p className="text-charcoal/70" data-id="element-3708">
                  Downloadable instantly as a secure PDF once you pass the final
                  assessment (70% pass rate)
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-3709">
              <BadgeCheckIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-3710" />
              <div data-id="element-3711">
                <p className="font-medium text-charcoal" data-id="element-3712">Valid for 3 Years</p>
                <p className="text-charcoal/70" data-id="element-3713">
                  Industry standard validity period, with renewal reminders
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-3714">
              <BadgeCheckIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-3715" />
              <div data-id="element-3716">
                <p className="font-medium text-charcoal" data-id="element-3717">
                  Digital Verification
                </p>
                <p className="text-charcoal/70" data-id="element-3718">
                  QR code for instant certificate verification
                </p>
              </div>
            </div>
          </div>
          <div className="flex items-center p-4 bg-teal/10 rounded-lg mb-6" data-id="element-3719">
            <DownloadIcon className="h-6 w-6 text-teal mr-4 flex-shrink-0" data-id="element-3720" />
            <p className="text-charcoal/80" data-id="element-3721">
              Your certificate is available for download immediately after
              completion and is valid for 3 years.
            </p>
          </div>
          <div className="p-6 bg-amber-50 rounded-lg border border-amber-200 mb-6 shadow-sm" data-id="element-3722">
            <div className="flex items-start" data-id="element-3723">
              <div className="w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-3724">
                <ShieldIcon className="h-6 w-6 text-amber-600" data-id="element-3725" />
              </div>
              <div data-id="element-3726">
                <h3 className="font-bold text-charcoal text-lg mb-2" data-id="element-3727">
                  100% Acceptance Guarantee
                </h3>
                <p className="text-charcoal/80 mb-3" data-id="element-3728">
                  We guarantee that your certificate will be accepted by all
                  Environmental Health Officers and food safety inspectors
                  throughout Ireland.
                </p>
                <p className="text-charcoal/80 font-medium" data-id="element-3729">
                  If your certificate is ever rejected during an inspection,
                  we'll refund your purchase in full and provide a replacement
                  certificate at no cost.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="relative" data-id="element-3730">
          <div className="bg-white rounded-xl shadow-xl overflow-hidden border border-gray-200" data-id="element-3731">
            <img src="https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80" alt="Food Safety Certificate Ireland" className="w-full h-auto" data-id="element-3732" />
            <div className="absolute top-4 right-4" data-id="element-3733">
              <div className="bg-teal text-white text-sm font-medium px-4 py-2 rounded-full shadow-lg" data-id="element-3734">
                Sample Certificate
              </div>
            </div>
          </div>
          <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-xl shadow-xl border border-gray-100 max-w-xs" data-id="element-3735">
            <div className="flex items-center mb-3" data-id="element-3736">
              <div className="w-8 h-8 rounded-full bg-teal flex items-center justify-center mr-3" data-id="element-3737">
                <ShieldCheckIcon className="h-4 w-4 text-white" data-id="element-3738" />
              </div>
              <h4 className="font-bold text-charcoal" data-id="element-3739">
                Certificate Validity Checker
              </h4>
            </div>
            <p className="text-charcoal/70 text-sm mb-3" data-id="element-3740">
              Verify the authenticity of any certificate using our online
              verification tool. Simply enter the certificate ID.
            </p>
            <a href="/verify-certificate" className="block text-center py-2 px-4 bg-teal text-white font-medium rounded-md hover:bg-teal/90 transition-all duration-300 shadow-sm" data-id="element-3741">
              Check Now
            </a>
          </div>
        </div>
      </div>
      <div className="mt-16 p-6 bg-white rounded-lg border border-gray-200 shadow-sm" data-id="element-3742">
        <h3 className="text-xl font-bold mb-4 text-charcoal" data-id="element-3743">
          For Business Customers
        </h3>
        <p className="text-charcoal/70 mb-6" data-id="element-3744">
          For businesses enrolling multiple staff members, our team dashboard
          provides:
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3745">
          <div className="flex items-start" data-id="element-3746">
            <div className="w-8 h-8 rounded-full bg-teal/10 flex items-center justify-center mr-3 flex-shrink-0" data-id="element-3747">
              <CheckIcon className="h-4 w-4 text-teal" data-id="element-3748" />
            </div>
            <div data-id="element-3749">
              <p className="font-medium text-charcoal" data-id="element-3750">
                Certificate Management
              </p>
              <p className="text-charcoal/70" data-id="element-3751">
                Store and access all employee certificates in one place
              </p>
            </div>
          </div>
          <div className="flex items-start" data-id="element-3752">
            <div className="w-8 h-8 rounded-full bg-teal/10 flex items-center justify-center mr-3 flex-shrink-0" data-id="element-3753">
              <CheckIcon className="h-4 w-4 text-teal" data-id="element-3754" />
            </div>
            <div data-id="element-3755">
              <p className="font-medium text-charcoal" data-id="element-3756">Expiry Tracking</p>
              <p className="text-charcoal/70" data-id="element-3757">
                Automated alerts when certificates are approaching renewal
              </p>
            </div>
          </div>
          <div className="flex items-start" data-id="element-3758">
            <div className="w-8 h-8 rounded-full bg-teal/10 flex items-center justify-center mr-3 flex-shrink-0" data-id="element-3759">
              <CheckIcon className="h-4 w-4 text-teal" data-id="element-3760" />
            </div>
            <div data-id="element-3761">
              <p className="font-medium text-charcoal" data-id="element-3762">Compliance Reports</p>
              <p className="text-charcoal/70" data-id="element-3763">
                Generate reports for regulatory inspections and audits
              </p>
            </div>
          </div>
          <div className="flex items-start" data-id="element-3764">
            <div className="w-8 h-8 rounded-full bg-teal/10 flex items-center justify-center mr-3 flex-shrink-0" data-id="element-3765">
              <CheckIcon className="h-4 w-4 text-teal" data-id="element-3766" />
            </div>
            <div data-id="element-3767">
              <p className="font-medium text-charcoal" data-id="element-3768">Bulk Printing</p>
              <p className="text-charcoal/70" data-id="element-3769">
                Print multiple certificates at once for record-keeping
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
const AccessibilityContent = () => {
  return <div className="max-w-6xl mx-auto px-4" data-id="element-3770">
      <h2 className="text-3xl font-bold mb-8 text-charcoal" data-id="element-3771">
        Course Accessibility
      </h2>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-3772">
        <div data-id="element-3773">
          <p className="text-lg text-charcoal/80 mb-8" data-id="element-3774">
            We believe in making food safety education accessible to everyone.
            Our courses are designed to accommodate various learning styles and
            language proficiencies, ensuring that all team members can
            successfully complete their training.
          </p>
          <div className="space-y-8 mb-8" data-id="element-3775">
            <div className="bg-white rounded-xl p-6 shadow-md border border-gray-100" data-id="element-3776">
              <div className="flex items-start" data-id="element-3777">
                <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-3778">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-teal" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-3779">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" data-id="element-3780" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 22V12h6v10" data-id="element-3781" />
                  </svg>
                </div>
                <div data-id="element-3782">
                  <h3 className="font-bold text-charcoal text-xl mb-3" data-id="element-3783">
                    Closed Captions (CC)
                  </h3>
                  <p className="text-charcoal/70" data-id="element-3784">
                    All video lessons include accurate closed captions, making
                    it easier for those with hearing impairments or non-native
                    English speakers to follow along. Captions can be toggled on
                    or off according to your preference.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md border border-gray-100" data-id="element-3785">
              <div className="flex items-start" data-id="element-3786">
                <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-3787">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-teal" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-3788">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" data-id="element-3789" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-3790" />
                  </svg>
                </div>
                <div data-id="element-3791">
                  <h3 className="font-bold text-charcoal text-xl mb-3" data-id="element-3792">
                    Video-Based Learning
                  </h3>
                  <p className="text-charcoal/70" data-id="element-3793">
                    Our courses use high-quality video content broken down into
                    short, digestible segments (typically 3-5 minutes) to
                    maintain engagement and improve retention. Visual
                    demonstrations help clarify complex concepts for all
                    learning styles.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md border border-gray-100" data-id="element-3794">
              <div className="flex items-start" data-id="element-3795">
                <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-3796">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-teal" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-3797">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-3798" />
                  </svg>
                </div>
                <div data-id="element-3799">
                  <h3 className="font-bold text-charcoal text-xl mb-3" data-id="element-3800">
                    Simplified Assessment Format
                  </h3>
                  <p className="text-charcoal/70" data-id="element-3801">
                    All assessments use multiple-choice questions with clear,
                    straightforward language. This format reduces language
                    barriers and allows learners to demonstrate their
                    understanding without struggling with complex question
                    formats.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md border border-gray-100" data-id="element-3802">
              <div className="flex items-start" data-id="element-3803">
                <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-3804">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-teal" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-3805">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" data-id="element-3806" />
                  </svg>
                </div>
                <div data-id="element-3807">
                  <h3 className="font-bold text-charcoal text-xl mb-3" data-id="element-3808">
                    Plain Language Instruction
                  </h3>
                  <p className="text-charcoal/70" data-id="element-3809">
                    We use simple, clear English throughout our courses,
                    avoiding unnecessary jargon and complex terminology. This
                    ensures that learners with varying levels of English
                    proficiency can understand and apply the content
                    successfully.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="p-6 bg-teal/10 rounded-lg border border-teal/20" data-id="element-3810">
            <div className="flex items-start" data-id="element-3811">
              <div className="w-10 h-10 rounded-full bg-teal/20 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-3812">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-teal" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-3813">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-3814" />
                </svg>
              </div>
              <div data-id="element-3815">
                <h3 className="font-bold text-charcoal mb-2" data-id="element-3816">
                  Need Additional Assistance?
                </h3>
                <p className="text-charcoal/80" data-id="element-3817">
                  If you or your team members require any specific
                  accommodations, our support team is here to help. Contact us
                  at support@foodsafety.ie and we'll work with you to ensure
                  everyone can successfully complete their training.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div data-id="element-3818">
          <div className="sticky top-32" data-id="element-3819">
            <h3 className="text-2xl font-bold mb-6 text-charcoal" data-id="element-3820">
              Success Stories
            </h3>
            <div className="space-y-6" data-id="element-3821">
              <div className="bg-white rounded-xl p-6 shadow-md border border-gray-100" data-id="element-3822">
                <div className="flex items-center mb-4" data-id="element-3823">
                  <div className="flex" data-id="element-3824">
                    {[...Array(5)].map((_, i) => <svg key={i} xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-amber-400" viewBox="0 0 20 20" fill="currentColor" data-id="element-3825">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-3826" />
                      </svg>)}
                  </div>
                  <span className="ml-2 text-sm text-charcoal/60" data-id="element-3827">
                    Verified Review
                  </span>
                </div>
                <blockquote className="text-charcoal/80 italic mb-6" data-id="element-3828">
                  "Honestly, I found it to be fantastic, it was very clear and
                  concise and extremely well laid out. Impressed with how the
                  material is broken down into bite size clips and then the pop
                  quiz at the end of each section. I think it is the best
                  content I have come across in my 18 years. I always try to
                  offer constructive criticism, honestly, I don't know if there
                  is any way to improve the content, it is crystal clear, the
                  fact that my staff with limited English was able to understand
                  and power through it speaks volumes."
                </blockquote>
                <div className="flex items-center" data-id="element-3829">
                  <div className="w-12 h-12 rounded-full bg-teal/20 flex items-center justify-center mr-4 flex-shrink-0 text-teal font-bold text-xl" data-id="element-3830">
                    OS
                  </div>
                  <div data-id="element-3831">
                    <p className="font-bold text-charcoal" data-id="element-3832">One Squared</p>
                    <p className="text-charcoal/60 text-sm" data-id="element-3833">
                      HACCP Course Graduate
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-md border border-gray-100" data-id="element-3834">
                <div className="flex items-center mb-4" data-id="element-3835">
                  <div className="flex" data-id="element-3836">
                    {[...Array(5)].map((_, i) => <svg key={i} xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-amber-400" viewBox="0 0 20 20" fill="currentColor" data-id="element-3837">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-3838" />
                      </svg>)}
                  </div>
                  <span className="ml-2 text-sm text-charcoal/60" data-id="element-3839">
                    Verified Review
                  </span>
                </div>
                <blockquote className="text-charcoal/80 italic mb-6" data-id="element-3840">
                  "Professionally prepared courses. I was able to get all our
                  staff at two different locations trained in HACCP without any
                  downtime for the business. The courses are really clear and
                  understandable even for my employees not fluent in English, I
                  would highly recommend it. I was also really surprised with
                  the quick responses from customer support. Lauren is excellent
                  and helped every step of the way."
                </blockquote>
                <div className="flex items-center" data-id="element-3841">
                  <div className="w-12 h-12 rounded-full bg-teal/20 flex items-center justify-center mr-4 flex-shrink-0 text-teal font-bold text-xl" data-id="element-3842">
                    PL
                  </div>
                  <div data-id="element-3843">
                    <p className="font-bold text-charcoal" data-id="element-3844">Przemek</p>
                    <p className="text-charcoal/60 text-sm" data-id="element-3845">Little Acorn Ltd</p>
                  </div>
                </div>
              </div>
              <div className="p-6 bg-amber-50 rounded-lg border border-amber-200" data-id="element-3846">
                <div className="flex items-start" data-id="element-3847">
                  <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-3848">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-3849">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" data-id="element-3850" />
                    </svg>
                  </div>
                  <div data-id="element-3851">
                    <h3 className="font-bold text-charcoal mb-2" data-id="element-3852">
                      Language Support Success
                    </h3>
                    <p className="text-charcoal/80" data-id="element-3853">
                      Our courses have been successfully completed by staff
                      members from over 40 countries with varying levels of
                      English proficiency. The clear, visual instruction and
                      simple language ensure everyone can learn effectively.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
const ReviewsContent = () => {
  const reviews = [{
    id: 1,
    name: "Sarah O'Connor",
    role: 'Café Manager, Dublin',
    rating: 5,
    content: 'This course was exactly what our team needed. Clear, concise, and fully compliant with FSAI requirements. The certificate was accepted without question during our recent EHO inspection.',
    date: 'March 15, 2023'
  }, {
    id: 2,
    name: 'Michael Brennan',
    role: 'Restaurant Owner, Cork',
    rating: 5,
    content: "I've enrolled all my new staff in this course. The team dashboard makes it easy to track who has completed the training and when certificates need to be renewed. Highly recommended for Irish food businesses.",
    date: 'February 8, 2023'
  }, {
    id: 3,
    name: 'Aoife Kelly',
    role: 'Food Service Worker, Galway',
    rating: 4,
    content: 'A comprehensive introduction to food safety that was easy to follow. The interactive elements kept me engaged throughout, and I feel much more confident in my role now.',
    date: 'April 22, 2023'
  }, {
    id: 4,
    name: 'John Murphy',
    role: 'Deli Counter Assistant, Limerick',
    rating: 5,
    content: 'As someone new to the food industry, this course gave me all the essential information I needed. The sections on cross-contamination and temperature control were particularly helpful.',
    date: 'January 30, 2023'
  }];
  return <div className="max-w-6xl mx-auto" data-id="element-3854">
      <h2 className="text-3xl font-bold mb-8 text-charcoal" data-id="element-3855">
        Customer Reviews
      </h2>
      <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200 mb-10" data-id="element-3856">
        <div className="flex items-center mb-4" data-id="element-3857">
          <div className="flex mr-4" data-id="element-3858">
            {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-6 w-6 text-amber-400" data-id="element-3859" />)}
          </div>
          <span className="text-xl font-bold text-charcoal" data-id="element-3860">4.8 out of 5</span>
        </div>
        <p className="text-charcoal/70" data-id="element-3861">
          Based on 1,240+ verified reviews from Irish food businesses and
          workers
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10" data-id="element-3862">
        {reviews.map(review => <div key={review.id} className="bg-white rounded-lg p-6 shadow-sm border border-gray-200" data-id="element-3863">
            <div className="flex justify-between items-start mb-4" data-id="element-3864">
              <div data-id="element-3865">
                <h3 className="font-bold text-lg text-charcoal" data-id="element-3866">
                  {review.name}
                </h3>
                <p className="text-charcoal/60 text-sm" data-id="element-3867">{review.role}</p>
              </div>
              <div className="flex" data-id="element-3868">
                {[...Array(review.rating)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-amber-400" data-id="element-3869" />)}
              </div>
            </div>
            <p className="text-charcoal/80 mb-3" data-id="element-3870">{review.content}</p>
            <p className="text-charcoal/60 text-sm" data-id="element-3871">{review.date}</p>
          </div>)}
      </div>
      <div className="text-center" data-id="element-3872">
        <a href="/reviews" className="inline-flex items-center text-teal font-medium hover:text-teal/80 transition-colors" data-id="element-3873">
          Read all customer reviews
          <ChevronRightIcon className="ml-1 h-5 w-5" data-id="element-3874" />
        </a>
      </div>
    </div>;
};
const FaqContent = () => {
  const [openQuestion, setOpenQuestion] = useState(1);
  const toggleQuestion = questionId => {
    setOpenQuestion(openQuestion === questionId ? null : questionId);
  };
  const faqs = [{
    id: 1,
    question: 'Is food safety training mandatory in Ireland?',
    answer: 'Yes. All food handlers must complete food safety training that matches their work activity. Level 1 is the legal minimum for new employees in food businesses in Ireland, as required by the Food Safety Authority of Ireland (FSAI).'
  }, {
    id: 2,
    question: 'When must training be completed?',
    answer: 'According to FSAI requirements, Stage I induction training must be completed before food handling begins, and Stage II within the first month of employment. This course covers both stages to ensure full compliance.'
  }, {
    id: 3,
    question: 'How long does the certificate last?',
    answer: 'Certificates should be refreshed every 2–3 years or when legislation, company procedures, or your role changes. This is in line with FSAI best practice guidance for food businesses in Ireland.'
  }, {
    id: 4,
    question: 'Who recognises this certificate?',
    answer: 'The certificate is recognised by Irish employers, Environmental Health Officers (EHOs), and food safety inspectors as proof of compliance with FSAI guidelines. It can be presented during official inspections and audits.'
  }, {
    id: 5,
    question: 'Do I need Level 2 HACCP training?',
    answer: 'Yes, if you prepare or handle high-risk or open foods, you must complete Level 2 Food Safety (HACCP) training within 3 months of starting work. This is an additional requirement beyond the Level 1 training.'
  }, {
    id: 6,
    question: 'How do I access the course?',
    answer: 'Once enrolled, you can access the course immediately through our online learning platform. The course is 100% online and can be completed on any device with internet access - computer, tablet, or smartphone.'
  }];
  return <div className="max-w-6xl mx-auto" data-id="element-3875">
      <h2 className="text-3xl font-bold mb-8 text-charcoal" data-id="element-3876">
        Frequently Asked Questions
      </h2>
      <p className="text-lg text-charcoal/70 mb-8" data-id="element-3877">
        Find answers to common questions about our Level 1 Food Safety course
        for Ireland
      </p>
      <div className="space-y-4 mb-8" data-id="element-3878">
        {faqs.map(faq => <div key={faq.id} className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-3879">
            <button onClick={() => toggleQuestion(faq.id)} className="flex items-center justify-between w-full p-6 bg-white hover:bg-gray-50 transition-colors text-left" data-id="element-3880">
              <h3 className="text-lg font-bold text-charcoal" data-id="element-3881">
                {faq.question}
              </h3>
              {openQuestion === faq.id ? <MinusIcon className="h-5 w-5 text-teal flex-shrink-0" data-id="element-3882" /> : <PlusIcon className="h-5 w-5 text-teal flex-shrink-0" data-id="element-3883" />}
            </button>
            {openQuestion === faq.id && <div className="p-6 bg-gray-50 border-t border-gray-200" data-id="element-3884">
                <p className="text-charcoal/80" data-id="element-3885">{faq.answer}</p>
              </div>}
          </div>)}
      </div>
      <div className="p-6 bg-teal/10 rounded-lg border border-teal/20" data-id="element-3886">
        <div className="flex items-start" data-id="element-3887">
          <MessageCircleIcon className="h-5 w-5 text-teal mt-1 mr-3 flex-shrink-0" data-id="element-3888" />
          <div data-id="element-3889">
            <h3 className="font-bold text-charcoal mb-2" data-id="element-3890">
              Still have questions?
            </h3>
            <p className="text-charcoal/70 mb-4" data-id="element-3891">
              Our team is here to help with any questions you may have about
              food safety training requirements in Ireland.
            </p>
            <a href="/contact" className="inline-flex items-center text-teal font-medium hover:text-teal/80 transition-colors" data-id="element-3892">
              Contact our support team
              <ChevronRightIcon className="ml-1 h-5 w-5" data-id="element-3893" />
            </a>
          </div>
        </div>
      </div>
    </div>;
};